const ALWAYS_TRANSCODE_TYPES = ['image/avif', 'image/heic', 'image/heif']

export async function resizeImageForUpload(
  file: File,
  maxDimension = 800,
): Promise<File> {
  if (!file.type.startsWith('image/')) {
    return file
  }

  const mustTranscode = ALWAYS_TRANSCODE_TYPES.includes(file.type)

  let bitmap: ImageBitmap
  try {
    bitmap = await createImageBitmap(file)
  } catch {
    return file
  }

  const { width, height } = bitmap

  if (!mustTranscode && width <= maxDimension && height <= maxDimension) {
    bitmap.close()
    return file
  }

  const scale = Math.min(1, maxDimension / width, maxDimension / height)
  const targetWidth = Math.round(width * scale)
  const targetHeight = Math.round(height * scale)

  const canvas = new OffscreenCanvas(targetWidth, targetHeight)
  const ctx = canvas.getContext('2d')!
  ctx.drawImage(bitmap, 0, 0, targetWidth, targetHeight)
  bitmap.close()

  const blob = await canvas.convertToBlob({ type: 'image/jpeg', quality: 0.85 })
  const jpegName = file.name.replace(/\.[^.]+$/, '') + '.jpg'
  return new File([blob], jpegName, { type: 'image/jpeg' })
}
